module.exports = __webpack_public_path__ + "img/user_collection_null_logo.d7cd89fa.png";